<template>
    <div id="data-list-list-view" class="data-list-container">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4" >
                <label for="from" class="vs-input--label"> {{$t('From')}}</label>
                <datepicker  :placeholder="$t('From')" v-model="search.StartDate" class="vx-col  w-full" name="from" v-validate="'required'"></datepicker>    
            </div>
            <div class="vx-col lg:w-1/4" >
            
                <label for="to" class="vs-input--label"> {{$t('To')}}</label>
                <datepicker  :placeholder="$t('To')" v-model="search.EndDate" class="vx-col  w-full" name="to" v-validate="'required'"></datepicker> 
            </div>
            <div class="vx-col lg:w-1/4" >
                <p>{{$t('Course')}}</p>
                <v-select
                  label="Name"
                  class=" w-full"
                    autocomplete
                  v-model="search.CourseID"
                  :options="Courses"
                  :reduce="ID => ID.ID"
                />
                <!-- <vs-select autocomplete class=" w-full" label="Course "  v-model="search.CourseID" >
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Courses" />
                </vs-select> -->
            </div> 
            <div class="vx-col lg:w-1/4" >
                <p>{{$t('Instructor')}}</p>
                      <v-select
                          label="Name"
                          class=" w-full"
                            autocomplete
                          v-model="search.InstructorID"
                          :options="Instructors"
                          :reduce="ID => ID.ID"
                        />
              
            </div> 
             <div class="vx-col lg:w-1/4" style="padding-top:10px;padding-left:30px">
             <vs-radio v-model="CourseWithDetail" vs-name="GetByCourseWithDetails" vs-value="true">{{$t('ByExams')}} </vs-radio> 
             <vs-radio v-model="CourseWithDetail" vs-name="GetByCourseWithDetails" vs-value="false" style="padding-left:30px">{{$t('ByCourses')}} </vs-radio>
            </div> 
            <vs-button type="border" icon-pack="feather" class="mt-5" icon="icon-search" @click="ViewSearch">{{$t('Search')}}</vs-button>
        </div>
        
    <vs-table ref="table" v-if="CourseWithDetail=='true'" pagination :max-items="itemsPerPage" search :data="ExamsModel" >
        <template slot="thead">
           <vs-th sort-key="Name">{{$t('CourseClassCode')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
            
            <vs-th sort-key="Name">{{$t('ExamType')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Instructor')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Pass')}} %</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.CourseClassCode }}</p>
                </vs-td>
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.CourseName }}</p>
                </vs-td>
                
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.ExamType }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.InstructorName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.PassPercentage }}%</p>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>

    <vs-table ref="table" v-if="CourseWithDetail=='false'||CourseWithDetail==false" pagination :max-items="itemsPerPage" search :data="CoursePassModel" >
        <template slot="thead">
           <vs-th sort-key="Name">{{$t('CourseClassCode')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Instructors')}}</vs-th>
            <vs-th sort-key="Name">{{$t('Pass')}} %</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.CourseClassCode }}</p>
                </vs-td>
                <vs-td>
                    <p class="product-name font-medium ">{{ tr.CourseName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.InstructorName }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                    <p class="product-name font-medium ">{{ tr.PassPercentage }}%</p>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div>  
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import moduleCourseClassExam from "@/store/courseClassExam/moduleCourseClassExam.js";
import vSelect from 'vue-select';
export default {

    components: {
        Datepicker,
        vSelect
    },
    computed:{
      
       Courses() {
         return this.$store.state.courseList.courses;
      },
       Instructors() {
          return this.$store.state.instructorList.instructors;
        }
    },
    data(){
        return{
          CourseWithDetail:'false',
            itemsPerPage: 10,
            search:{},
            ExamsModel:[],
            CoursePassModel:[],
        }
    },
    methods:{
        ViewSearch()
        {
           this.$vs.loading();
          debugger;
          if(this.CourseWithDetail=='true'){
            
             this.$store.dispatch("courseClassExamList/GetCourseClassExamPassStatistic",  this.search).then((res)=>{
                this.$vs.loading.close();
              this.ExamsModel = res.data;
            }).catch(err => {
              this.$vs.loading.close();
            });
          }
           else{
              this.$store.dispatch("courseClassExamList/GetCoursePassStatistic",  this.search).then((res)=>{
                 this.$vs.loading.close();
              this.CoursePassModel = res.data;
            }).catch(err => {
              this.$vs.loading.close();
            });
           }
        }
    },
    created()
    {
        if (!moduleCourse.isRegistered) {
            this.$store.registerModule("courseList", moduleCourse);
            moduleCourse.isRegistered = true;
            }
            this.$store.dispatch("courseList/fetchDataListItems");

            if (!moduleInstructor.isRegistered) {
                this.$store.registerModule("instructorList", moduleInstructor);
                moduleInstructor.isRegistered = true;
            }
            this.$store.dispatch("instructorList/fetchDataListItems");

             if (!moduleCourseClassExam.isRegistered) {
      this.$store.registerModule("courseClassExamList", moduleCourseClassExam);
      moduleCourseClassExam.isRegistered = true;
    }
    }
}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
